import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'
import moment from 'moment'
import TreeView from './TreeView'
import Views from './Views'
import Datepicker from './Datepicker'
import { apiConstants } from '../constants/apiConstants'
import * as Constants from '../constants/constants'
import InputBox from './InputBox'
import Dropdown from './Dropdown'

import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import caller from '../caller'

import { fetchDiskUsage } from '../api/request'
import { formatFileSize, renderRibbonNotification } from '../helper'

class MobileListView extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      showDatePicker: false,
      fileDetails: this.props.files,
      folderlist: this.props.folderList,
      selectionRange: {
        startDate:
          this.props.startDate === 0
            ? new Date()
            : new Date(this.props.startDate),
        endDate:
          this.props.endDate === 0 ? new Date() : new Date(this.props.endDate),
        key: 'selection',
      },
      baseFolder: this.props.baseFolder,
      sortType: this.props.sortType,
      sortBy: this.props.sortBy,
      isDateSelectionDone: false,
      searchValue: '',
      prevSearchValue: '',
      refresh: false,
      searchBy: 'allFiles',
      diskUsage: [],
      fetchDiskUsageInProgress: false,
    }
  }

  setRef = (ref) => {
    this.viewRef = ref
  }

  setTreeRef = (ref) => {
    this.treeRef = ref
  }

  componentDidMount() {
    const { userPermission, user } = this.props
    document.addEventListener('click', this.handleClick, false)
    document.addEventListener('keydown', this.handleKeydown, false)
    this.props.actions.setUserPermissionForFolder(userPermission)
    if (user.accType !== Constants.constants.AdhocUser) {
      this.getProfileData()
    }
  }

  getProfileData = async () => {
    this.setState({ fetchDiskUsageInProgress: true })
    const diskUsageResponse = await fetchDiskUsage('', {})

    if (diskUsageResponse.status === 200) {
      const result = _.get(JSON.parse(diskUsageResponse.text), 'diskUsages', [])
      this.setState({ diskUsage: result, fetchDiskUsageInProgress: false })
    } else {
      this.setState({ fetchDiskUsageInProgress: false })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { sortType, sortBy } = prevProps
    const { baseFolder } = this.props
    if (sortType !== prevState.sortType) {
      this.setStateValues('sortType', prevProps.sortType)
    }
    if (sortBy !== prevState.sortBy) {
      this.setStateValues('sortBy', prevProps.sortBy)
    }
    if (baseFolder !== prevProps.baseFolder) {
      this.setStateValues('baseFolder', baseFolder)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
    document.removeEventListener('keydown', this.handleKeydown, false)
  }

  setStateValues = (key, value) => {
    this.setState({ [key]: value })
  }

  handleClick = (e) => {
    const { showDatePicker, isDateSelectionDone } = this.state
    if (showDatePicker) {
      if (this.node.contains(e.target)) {
        return
      }
      if (e.target.id === 'dateSubmit_parent') {
        return
      }
      if (e.target.id === 'submit_date') {
        this.handleDateSubmit()
        return
      }
      if (e.target.classList.value.includes(' fv__datePicker')) {
        return
      }
      if (isDateSelectionDone) {
        this.handleDateSubmit()
      }
      this.setDatePickerVisibility(false)
    }
  }

  handleKeydown = (event) => {
    const { keyCode } = event
    const { showDatePicker } = this.state
    if (keyCode === 27) {
      if (showDatePicker) {
        this.setDatePickerVisibility(false)
      }
    }
  }

  onRefreshClick = () => {
    this.setState({ refresh: true, searchValue: '' })
  }

  onSharePermissionRequest = () => {
    this.props.setSharePermissionBoxVisibility(true)
  }

  setRefreshState = (refresh) => {
    this.setState({ refresh })
  }

  capture = (newFolder, folder) => {
    this.setState((prevState) => ({
      fileDetails: newFolder.concat(prevState.fileDetails),
      folderlist: folder.concat(prevState.folderlist),
    }))
  }

  setDatePickerVisibility = (val) => {
    this.setState({ showDatePicker: val, isDateSelectionDone: false })
  }

  handleDateSubmit = () => {
    const { selectionRange } = this.state
    const startDate = moment(selectionRange.startDate)
      .startOf('day')
      .format('x')
    const endDate = moment(selectionRange.endDate).endOf('day').format('x')
    this.props.actions.setStartDate(startDate)
    this.props.actions.setEndDate(endDate)
    this.props.actions.setSharedFolderDetails({})
    this.setDatePickerVisibility(false)
  }

  handleClearDate = () => {
    this.props.actions.setStartDate(0)
    this.props.actions.setEndDate(0)
    this.props.actions.setSharedFolderDetails({})
    this.setState({
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
      showDatePicker: false,
      isDateSelectionDone: false,
    })
  }

  handleSelect = (ranges) => {
    this.setState({
      selectionRange: ranges.selection,
      isDateSelectionDone: true,
    })
  }

  setBaseFolder = (path) => {
    this.setState({ searchValue: '', prevSearchValue: '' })
    this.props.actions.setBaseFolder(path === apiConstants.Root ? '/' : path)
  }

  updateFileListBasedOnSearch = (searchValue) => {
    const { user } = this.props
    caller.trackFPTI(user, ['search', 'searchBox'])
    this.viewRef.updateFileListBasedOnSearch(searchValue)
  }

  onSearchEnter = (e) => {
    const { searchValue, prevSearchValue } = this.state
    this.setState({ searchValue: e.target.value.trim() })
    this.updateFileListBasedOnSearch(e.target.value.trim())
    if (prevSearchValue !== '' && e.target.value === '' && searchValue !== '') {
      this.setState({ prevSearchValue: e.target.value.trim() })
      this.props.actions.setSharedFolderDetails({})
      this.updateFileListBasedOnSearch('')
    }
  }

  searchCapture = (evt) => {
    const { searchValue, prevSearchValue } = this.state
    if (
      evt.key === 'Enter' ||
      (typeof evt.key === 'undefined' &&
        searchValue !== '' &&
        prevSearchValue !== searchValue)
    ) {
      this.setState({ prevSearchValue: searchValue })
      this.props.actions.setSharedFolderDetails({})
      this.updateFileListBasedOnSearch(searchValue)
    } else if (typeof evt.key === 'undefined' && prevSearchValue === '') {
      if (searchValue !== '') {
        this.setState({
          searchValue: '',
        })
        this.updateFileListBasedOnSearch('')
      }
    } else if (typeof evt.key === 'undefined' && prevSearchValue !== '') {
      this.setState({
        searchValue: prevSearchValue,
      })
      this.updateFileListBasedOnSearch(prevSearchValue)
    }
  }

  clearSearchField = () => {
    this.setState({ searchValue: '', prevSearchValue: '' })
  }

  onSortOptionClick = (key, value) => {
    switch (key) {
      case 'sortBy':
        this.props.actions.setSortBy(value)
        break
      case 'sortType':
        this.props.actions.setSortType(value)
        break
      default:
        break
    }
  }

  treeViewFolderClick = (folder) => {
    this.setState(
      {
        searchBy: 'allFiles',
      },
      () => {
        this.viewRef.treeViewFolderClick(folder)
      },
    )
  }

  setErrorMessage = (err, file = {}, operation, isMsgToBeUpdated = true) => {
    return this.viewRef.constructErrorMessage(
      err,
      file,
      operation,
      isMsgToBeUpdated,
    )
  }

  onUploadFailure = (filesToUpload, item, status, message) => {
    return this.viewRef.onFailure(filesToUpload, item, status, message)
  }

  validateFileBeforeUpload = (filesToUpload) => {
    this.viewRef.validateFileBeforeUpload(filesToUpload)
  }

  validateSelectedFilesToUpload = (filesToUpload) => {
    return this.viewRef.validateSelectedFilesToUpload(filesToUpload)
  }

  triggerTreeViewFetch = (path, from = '', internal = false) => {
    this.treeRef.fetchFolderData(path, from, internal)
  }

  setFolderStructure = (folderList) => {
    this.treeRef.setFolderStructure(folderList)
  }

  setQuickSearch = (searchBy) => {
    this.setState({ searchBy })
  }

  getQuickSearchName = (searchBy) => {
    if (searchBy === 'sharedWith') return 'sharedWithMe'
    if (searchBy === 'sharedBy') return 'sharedByMe'
    return 'home'
  }

  renderDatePicker = () => {
    const { showDatePicker, selectionRange } = this.state
    const { startDate, endDate } = this.props
    const startDateValue =
      startDate === 0
        ? ''
        : `${
            selectionRange.startDate.getMonth() + 1
          }/${selectionRange.startDate.getDate()}/${selectionRange.startDate.getFullYear()}`
    const endDateValue =
      endDate === 0
        ? ''
        : `${
            selectionRange.endDate.getMonth() + 1
          }/${selectionRange.endDate.getDate()}/${selectionRange.endDate.getFullYear()}`
    return (
      <div className="datePicker__container" ref={(node) => (this.node = node)}>
        <div className="datePicker__mobile-container fv__datePicker">
          <div className="datePicker__icon-mobile fv__datePicker">
            <span
              className="ppvx_icon ppvx_icon--size_lg ppvx_icon-calendar fv__datePicker"
              onClick={() => this.setDatePickerVisibility(true)}
            />
          </div>
        </div>
        <div className="datePicker__desktop">
          <div className="datePicker__desktop-holder">
            <div
              className="datePicker__desktop-container"
              onClick={() => this.setDatePickerVisibility(true)}
            >
              <div className="datePicker__desktop-content">
                <label className="datePicker__input-label">
                  <Message id="datepicker.start" />
                </label>
                <input
                  className="datePicker__input"
                  type="text"
                  placeholder="MM/DD/YY"
                  value={startDateValue}
                  disabled
                />
              </div>
            </div>
            <div
              className="datePicker__desktop-container"
              onClick={() => this.setDatePickerVisibility(true)}
            >
              <div className="datePicker__desktop-content">
                <label className="datePicker__input-label">
                  <Message id="datepicker.end" />
                </label>
                <input
                  className="datePicker__input"
                  type="text"
                  placeholder="MM/DD/YY"
                  value={endDateValue}
                  disabled
                />
              </div>
              <div className="datePicker__icon">
                <span
                  className="ppvx_icon ppvx_icon--size_lg ppvx_icon-calendar"
                  onClick={() => this.setDatePickerVisibility(true)}
                />
              </div>
            </div>
          </div>
        </div>
        {showDatePicker && (
          <Datepicker
            {...this.props}
            selectionRange={selectionRange}
            handleSelect={this.handleSelect}
            handleDateSubmit={this.handleDateSubmit}
            handleClearDate={this.handleClearDate}
          />
        )}
      </div>
    )
  }

  handleOnSelect = (index) => {
    const searchBy = Constants.constants.Filters.savedSearch[index].key
    caller.trackFPTI(this.props.user, [
      'search',
      this.getQuickSearchName(searchBy),
    ])
    const searchQuery = searchBy !== 'allFiles' ? { quickSearch: searchBy } : {}
    this.setState(
      {
        searchBy,
      },
      () => {
        this.props.actions.setSharedFolderDetails({})
        this.props.actions.setBaseFolder('/')
        this.props.history.push(`${apiConstants.URLPrefix}`)
        this.viewRef.onFilterChange(searchQuery)
      },
    )
  }

  renderSavedSearch = () => {
    return (
      <div className="quickSearch_dropdown">
        <Dropdown
          label=""
          className="dropdown-menu"
          options={Constants.constants.Filters.savedSearch}
          value={this.fetchSelectValue()}
          handleOnSelect={this.handleOnSelect}
          style={{}}
        />
      </div>
    )
  }

  fetchSelectValue = () => {
    const { searchBy } = this.state
    const searchQuery = Constants.constants.Filters.savedSearch.filter(
      function (value) {
        return value.key === searchBy
      },
    )
    return searchQuery[0].value
  }

  renderSearch = () => {
    const { searchValue } = this.state
    const { user } = this.props
    return (
      <div className="search-container">
        {user.accType !== Constants.constants.AdhocUser &&
          this.renderSavedSearch()}
        <div className="seacrh-input">
          <InputBox
            name="search_files"
            id="search_files"
            value={searchValue}
            className="search-input-box input-box input-box__search"
            label="Search files"
            isLabelHidden={true}
            placeholder="labels.search.placeholder"
            onChangeText={(e) => this.onSearchEnter(e)}
            onKeyPressText={(e) => this.searchCapture(e)}
            onBlurText={(e) => this.searchCapture(e)}
            maxLength={200}
            autoFocus={false}
            style={{}}
          />
        </div>
        <div
          className="search-icon hide_mobile"
          onClick={() => this.updateFileListBasedOnSearch(searchValue)}
        >
          <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-search" />
        </div>
      </div>
    )
  }

  renderViewComponent = () => {
    const { refresh } = this.state
    return (
      <div className="view__container-outline">
        <TreeView
          ref={this.setTreeRef}
          {...this.props}
          treeViewFolderClick={this.treeViewFolderClick}
          setErrorMessage={this.setErrorMessage}
          refresh={refresh}
          setRefreshState={this.setRefreshState}
        />
        {this.renderViews()}
      </div>
    )
  }

  renderViews = () => {
    const { baseFolder, refresh } = this.state
    return (
      <Views
        ref={this.setRef}
        {...this.props}
        baseFolder={baseFolder}
        setUploadFileBoxVisibility={this.props.setUploadFileBoxVisibility}
        setShareBoxVisibility={this.props.setShareBoxVisibility}
        capture={this.capture}
        setBaseFolder={this.setBaseFolder}
        refresh={refresh}
        setRefreshState={this.setRefreshState}
        triggerTreeViewFetch={this.triggerTreeViewFetch}
        clearSearchField={this.clearSearchField}
        setFolderStructure={this.setFolderStructure}
        setQuickSearch={this.setQuickSearch}
        handleClearDate={this.handleClearDate}
      />
    )
  }

  renderSortType = () => {
    const { sortType } = this.state
    return (
      <div className="sort__by-container">
        <div className="sort__by-content">
          {Constants.constants.Filters.sortType.map((item, index) => {
            return (
              <div className="sort__by-type" key={`${item.name}_${index}`}>
                <input
                  type="radio"
                  name="sortType"
                  id={item.key}
                  value={item.key}
                  defaultChecked={item.key === sortType}
                  onClick={() => this.onSortOptionClick('sortType', item.key)}
                />
                <label htmlFor={item.key}>{item.name}</label>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderSortBy = () => {
    const { sortBy } = this.state
    return (
      <div>
        {Constants.constants.Filters.sortBy.map((item, index) => {
          return (
            <div
              className={`${
                sortBy === item.key ? 'filter__label--active' : ''
              } filter__category-box-label`}
              key={`${item.name}_${index}`}
              onClick={() => this.onSortOptionClick('sortBy', item.key)}
            >
              {item.name}
            </div>
          )
        })}
      </div>
    )
  }

  renderSort = () => {
    return (
      <div className="filter__category-box">
        <div className="filter__category-header">Sort by</div>
        <div className="filter__category-options">
          {this.renderSortBy()}
          {this.renderSortType()}
        </div>
      </div>
    )
  }

  renderRefresh = () => {
    const { user } = this.props
    return (
      <div className="refresh__container">
        <a
          data-pa-pgrp={`dropzone:${user.accType}`}
          data-pa-page={`dropzone:search:refresh:${user.accType}`}
          data-pa-click="refresh"
          className="ppvx_link flexAlignCenter"
          onClick={() => this.onRefreshClick()}
        >
          <span className="ppvx_icon ppvx_icon--size_xs ppvx_icon-refresh refresh__icon" />
          <span className="hide_mobile">
            <Message id="buttons.refresh" />
          </span>
        </a>
      </div>
    )
  }

  renderDiskUsageColor = (bytes) => {
    if (bytes >= Constants.constants.DiskUsageValue.alert) {
      return 'dist__usage_alert'
    } else if (bytes >= Constants.constants.DiskUsageValue.warning) {
      return 'dist__usage_warning'
    }
    return 'dist__usage_info'
  }

  renderDiskUsageMessage = (bytes) => {
    if (bytes >= Constants.constants.DiskUsageValue.alert) {
      return 'labels.diskUsage.alert'
    } else if (bytes >= Constants.constants.DiskUsageValue.warning) {
      return 'labels.diskUsage.warning'
    }
    return ''
  }

  renderDiskUsage = () => {
    const { diskUsage, fetchDiskUsageInProgress } = this.state
    const bytes = _.get(diskUsage, '[0].bytes', 0)
    return (
      <div className="disk__usage_container">
        <span className="ppvx_icon ppvx_icon--size_xl2 ppvx_icon-info-alt info__icon tooltip">
          <span
            className="tooltiptext ppvx_text--md disk__usage_tooltip"
            style={{ maxWidth: '225px' }}
          >
            <span>
              <Message id="labels.diskUsage.label" />
            </span>
            <span>
              <Message id={this.renderDiskUsageMessage(bytes)} />
            </span>
          </span>
        </span>
        {fetchDiskUsageInProgress ? (
          <div className="dist__usage_value disk__usage_dummy" />
        ) : (
          <div
            className={`dist__usage_value ppvx_text--md ${this.renderDiskUsageColor(
              bytes,
            )}`}
          >
            {formatFileSize(bytes)}
          </div>
        )}
      </div>
    )
  }

  render() {
    const { user } = this.props
    return (
      <div>
        {user.accType === Constants.constants.CorpUser &&
          renderRibbonNotification()}
        <div className="mobile-filters-container">
          <div className="mobile-filters">
            {this.renderDatePicker()}
            {this.renderSearch()}
            {this.renderRefresh()}
            {user.accType !== Constants.constants.AdhocUser &&
              this.renderDiskUsage()}
          </div>
        </div>
        {this.renderViewComponent()}
      </div>
    )
  }
}
export default MobileListView
